import { OperationVariables, QueryOptions } from "@apollo/client";
import { client } from "../apollo";

export function queryClient<
  T = any,
  TVariables extends OperationVariables = OperationVariables
>(options: QueryOptions<TVariables, T>) {
  return client.query(options);
}
